export default "<div name=\"termly-embed\" data-id=\"bc8dcfef-0848-49d0-abca-f47ff5183d59\" data-type=\"iframe\"></div>\n"